module.exports = __webpack_public_path__ + "assets/icons/icon_signal1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/svg/icon_signal1.svg
// module id = mJYQ
// module chunks = 1